import styled from 'styled-components';
import Img from 'gatsby-image';

const Logo = styled(Img)`
  width: 120px;
  height: 3rem;
`;

export default Logo;
